<template>
	<div id="app">
		<MainPage/>
	</div>
</template>

<script>

import MainPage from './components/MainPage.vue'

export default {
	name: 'app',
	components: {
		MainPage,
	}
}
</script>

<style>

body {
	overflow-y: scroll;
	display: inline;
	max-width: 100%;
	margin: 0;
}

html, body {
	overflow-x: hidden;
}

html {
	-webkit-overflow-scrolling: touch;
	display: inline;
	overflow: auto;
	position: relative;
	box-sizing: border-box;
	max-width: 100%;
}

#app {
	text-align: center;
	color: #2c3e50;
	margin-left: auto;
	margin-right: auto;
	position: relative;
	box-sizing: border-box;
	-webkit-overflow-scrolling: touch;
	max-width: 100%;}
</style>

